import React, { useMemo } from "react";
import { GridType } from "../../../../../types/grid";
import Grid from "../../../../atoms/Grid";
import { formatCurrency, formatNumber } from "../../../../libs/utils";
import { Invoice } from "../types";

const defaultSettings = {
  type: "fitCellContents",
};

const columns: GridType[] = [
  { field: "appliedSales", width: 160, type: "rightAligned" },
  { field: "percentage", width: 130, type: "rightAligned" },
  { field: "rawRent", headerName: "Initial rent", width: 150, type: "rightAligned" },
  { field: "finalRent", headerName: "Calculated rent", width: 150, type: "rightAligned" },
  { field: "minLimit", headerName: "Min limit", width: 150, type: "rightAligned" },
  { field: "uptoLimit", headerName: "Max limit", width: 150, type: "rightAligned" },
];

type TorLedgerProps = {
  invoice?: Invoice;
};

export const TorLedger = (props: TorLedgerProps) => {
  const { invoice } = props;

  const appliedRules = invoice?.torSummary?.appliedRules;

  const gridData = useMemo(() => {
    if (!appliedRules?.length) return [];

    return appliedRules.map((rule) => ({
      appliedSales: formatCurrency(rule?.appliedSales),
      percentage: formatNumber(rule?.percent),
      rawRent: formatCurrency(rule?.rawRent),
      finalRent: formatCurrency(rule?.finalRent),
      minLimit: formatCurrency(rule?.limits?.minLimit),
      uptoLimit: formatCurrency(rule?.limits?.uptoLimit),
    }));
  }, [appliedRules]);

  return <Grid className="p-0" columns={columns} data={gridData} defaultSettings={defaultSettings} />;
};
